import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { RadioElement, getDefaultCargoRequestValue, NOT_RESET_FIELDS } from './common';

import CollapseCustomizable from 'components/common/CollapseCustomizable';
import { updateCargoOrder as updateCargoOrderAction } from 'actions/cargoes/orders';
import Tank from './Tank';
import { fieldsMap, getValidateFields } from 'constants/validateFields';

function WetBulk({
    updateCargoOrder,
    numberOrderTable,
    cargoPackingIndex,
    cargoOrder,
    cargoPacking,
    canCheck = false,
    errors,
}) {
    const [disabledAll, setDisableAll] = useState(false);

    useEffect(() => {
        if (cargoPacking.category !== 'wetBulk') {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');

            NOT_RESET_FIELDS.forEach((field) => {
                metaPack[field] = cargoPacking.pack[field];
            });

            Object.values(fieldsMap).forEach(({ max }) => {
                cargoOrder.validateErrors = cargoOrder.validateErrors
                    .filter(obj => obj.field !== `packing.pack.${max}`);
            });

            setDisableAll(true);
            modifyFields([
                { field: 'packing.pack', value: metaPack },
                { field: 'validateErrors', value: cargoOrder.validateErrors },
            ]);
        } else {
            setDisableAll(false);
        }
    }, [cargoPacking.category]);

    useEffect(() => {
        if (!cargoPacking.pack.flammable) {
            modifyFields([{ field: 'packing.pack.flashPointMin', value: undefined }]);
        }
    }, [cargoPacking.pack.flammable]);
    
    /**
     * 
     * @param {{ field: string, value: any }[]} changes
     */
    const modifyFields = (changes) => {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        const newCargoOrder = _.cloneDeep(cargoOrder);

        changes.forEach(({ field, value }) => {
            _.set(newCargoOrder.cargo[cargoPackingIndex], field, value);

            const fieldToValidate = getValidateFields(field);

            if (fieldToValidate) {
                const { min, max } = fieldToValidate;

                if (!newCargoOrder.cargo[cargoPackingIndex].packing.pack[max]) {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors
                        .filter(obj => obj.field !== `packing.pack.${max}`);
                } else if (
                    +newCargoOrder.cargo[cargoPackingIndex].packing.pack[min] > 
                    +(newCargoOrder.cargo[cargoPackingIndex].packing.pack[max] || 0)
                ) {
                    newCargoOrder.validateErrors.push({
                        field: `packing.pack.${max}`,
                        messages: ['Min is greater than max'],
                    });
                } else {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors
                        .filter(obj => obj.field !== `packing.pack.${max}`);
                }
            }
        });

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return (<div><CollapseCustomizable 
        _key='wetBulk'
        head={
            <RadioElement 
                value='wetBulk' 
                checkedValue={cargoPacking.category}
                disabled={!canCheck}
                onCheck={() => modifyFields([{ field: 'packing.category', value: 'wetBulk' }])}
                label='wetBulk' 
                _key='wetBulk' 
            />
        }
        headStyle={{ borderBottom: '1px solid #E0E0E0' }}
        body={
            <Tank
                category='wetBulk'
                cargoPacking={cargoPacking}
                disabledAll={disabledAll}
                modifyFields={modifyFields}
                errors={errors}
            />
        }
    />
    </div>);
}

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        const cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;

        const errors = {
            pourPointMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.pourPointMax'),
            boilingPointMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.boilingPointMax'),
            meltingPointMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.meltingPointMax'),

            voyageHeatMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.voyageHeatMax'),
            loadingHeatMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.loadingHeatMax'),
            dischargeHeatMax: cargoOrder.validateErrors
                .find(validateError => validateError.field === 'packing.pack.dischargeHeatMax'),
        };

        return {
            cargoOrder,
            cargoPacking,
            errors,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder: updateCargoOrderAction,
    }, dispatch),
)(WetBulk));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/WetBulk.jsx